import React from 'react'; 

import { Heading, ProcessStep } from '../../../components';
import { process } from '../../../constants';

// import Swiper core and required modules 
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Process = () => {

  return (

    <section>

      {/* Section heading */}
      <Heading title={'Our Process'} subTitle={'How We Work'} />

      <div className='process-slider'>

        <Swiper
          // install Swiper modules
          modules={[Autoplay]}
          spaceBetween={10} // Space between slides
          loop={true} // Enable infinite loop
          autoplay={{ delay: 3500, disableOnInteraction: false }} // Auto-play settings
          breakpoints={{
            450: { slidesPerView: 1 }, // 1 slide for small screens
            768: { slidesPerView: 2 }, // 2 slides for tablets
            991: { slidesPerView: 3 }, // 3 slides for larger screens
          }}
        >
          {// Mapping through the process array to create slides
            process.map((step, index) => {
              return (
                <SwiperSlide key={index}>

                  <ProcessStep step={step} />

                </SwiperSlide>
              )
            })
          }

        </Swiper>

      </div>

    </section>

  );
}

export default Process;